import {FargeHex} from "../tjenester/ressurser/generertNg2HttpKlient";
import {cubehelix, rgb} from "d3";


/**
 * Cubehelix vekting for lysstyrke, dette tilsvarer opplevd lysstyrke i Dave Greens modell
 *
 * @return 0.0 - 1.0, der 0 er hvit og 1 er sort om man snakker om en gråfarge-skala
 */
export function cubehelixLyshetForFarge(farge: FargeHex): number {
    //se no.systemfabrikken.lederplan.infrastruktur.datatyper.FargeHex.cubehelixLyshet i javakoden for en alternativ beregning som ikke bruker d3 biblioteket
    const rgbFarge = rgb(farge);
    return cubehelix(rgbFarge).l
}

/**
 * Returnerer en ny farge som er lysere enn denne fargen.
 *
 * @param faktor hvor mye hvitere fargen skal gjøres (0.0 til 1.0), 0.6 betyr 60% nærmere hvit.
 */
export function gjørFargeLysere(farge: FargeHex, faktor: number): FargeHex {
    const rgbFarge = rgb(farge);
    return rgb(lysne(rgbFarge.r, faktor), lysne(rgbFarge.g, faktor), lysne(rgbFarge.b, faktor)).formatHex();
}

function lysne(fargeverdi: number, faktor: number) {
    return Math.min(255, Math.round(fargeverdi + (255 - fargeverdi) * faktor));
}
